<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="mySocketTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">
            <template slot="operation" slot-scope="text, record">
                <!-- <router-link class="tableLink"  :to="{path:'edit_templete',query: {id: record.id,}}">编辑</router-link> -->
                <a-popconfirm title="确认重新推送?" @confirm="() => handleRepush(record)">
                    <a class="tableLink"  href="javascript:;">重新推送</a>
                </a-popconfirm>

                <a-button @click="handleParamsJsonMain(record)" type="link">详情</a-button>

            </template>

            <template slot="status_name" slot-scope="text">
                <span :style="{color:status_color[text]}">{{ status_text[text] }}</span>
            </template>

            <!-- 业务埋点Attrabutes -->
            <template slot="jsonParams" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParamsJson(record)" />
            </template>
            <!-- 设备号 -->
            <template slot="devicenoBtn" slot-scope="text,record">
                <a-button type="link" @click="handleDeviceNo(record)">{{ text }}</a-button>
            </template>
        </a-table>
        <a-modal v-model="jsonModalVisable" title="attributes">
                <json-viewer
                :value="jsonVData"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-modal>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};
import JsonViewer from "vue-json-viewer"
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
        fixed:'left'

    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
        fixed:'left'
    },
    {
        title: "消息记录ID",
        dataIndex: "messageid",
        width:180,
        ellipsis: true,
        align:'center'
    },
    {
        title: "消息ID",
        dataIndex: "messagepid",
        width:180,
        ellipsis: true,
        align:'center'
    },

    {
        title: "收信人",
        dataIndex: "receivervalue",
        width:200,
        ellipsis: true
    },
    {
        title: "",
        width:50,
        scopedSlots: { customRender: 'jsonParams' },
        align: "center",
    },
    {
        title: "收信设备",
        dataIndex: "deviceno",
        scopedSlots : { customRender: 'devicenoBtn' },  
        width:400,
        ellipsis: true
    },

    {
        title: "发送方式",
        dataIndex: "receivertypename",
        width:100,
        align:'center'
    },
    {
        title: "标题",
        dataIndex: "messagetitle",
        width:200,
        ellipsis: true,
        align:'center'
    },
    {
        title: "业务分类编码",
        dataIndex: "messagestypecode",
        width:150,
        align:'center'
    },
    {
        title: "业务分类",
        dataIndex: "messagestypename",
        width:120,
        align:'center'
    },
    {
        title: "业务类型编码",
        dataIndex: "messageservicecode",
        width:120,
        align:'center'
    },
    {
        title: "业务类型",
        dataIndex: "messageservicename",
        width:120,
        align:'center'
    },
    {
        title: "推送内容",
        dataIndex: "messageecontent",
        width:200,
        ellipsis: true,
        align:'center'
    },
    {
        title: "附加字段",
        dataIndex: "messageextras",
        width:100,
        ellipsis: true,
        align:'center'
    },
    {
        title: "发送时间",
        dataIndex: "messagesendtime",
        width:160,
        align:'center'
    },
    {
        title: "状态",
        dataIndex: "status",
        width:150,
        scopedSlots:{customRender:'status_name'},
        align:'center'
    },
    {
        title: "错误信息",
        dataIndex: "errormsg",
        width:160,
        align:'center',
        ellipsis: true,
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:160,
        align:'center'
    },
    {
        title: "更新时间",
        dataIndex: "updatetime",
        width:160,
        align:'center'
    },


];
const status_text = {
    '01':'未处理',
    '00':'处理失败',
    '03':'已发送',
    '02':'已完结',
    '04':'业务完成'
}
const status_color = {
    '01':'yellow',
    '00':'red',
    '03':'blue',
    '02':'green',
    '04':'green'
}
export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            orderstr:'desc',
            jsonModalVisable:false,
            searchP:{},
            jsonVData:[],
            status_text,
            status_color
        };
    },
    methods: {
        handleDeviceNo(item){
            
            let routeResolve = this.$router.resolve({
                path:"/mcmsmanager/target/wsdevice",
                query:{
                    deviceno:item.deviceno,
                }
            })
            window.open(routeResolve.href, '_blank');
        },
        handleParamsJson(item){
            this.jsonVData = item.receivervalue.split(',')
            this.jsonModalVisable = true;
        },
        handleParamsJsonMain(item){
            this.jsonVData = item;
            this.jsonModalVisable = true;
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleRepush(record){
            let that = this
            that.tloading = true;
            let params = {
                id:record.id,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/sendmsgthistory",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.message.success('发送成功')
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        getAppSumData(){
            let that = this
            that.tloading = true;
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/querymsghistorypage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        }
    },

    components:{
        JsonViewer
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

